<template>
    <header class="wc-kit__active-header">
        <h1>Overview</h1>
        <div>
            <h2 class="kit-subtitle">View your finished kit before adding it to your basket</h2>
        </div>
    </header>

    <ul class="kit-products">
        <li v-for="(product, key) in $store.getters.getAllCartProducts" :key="key">
            <Product :p-data="product.product" :is-overview="true" :cart-item="product" />
        </li>
    </ul>
</template>

<script>
    import Product from '../components/Product.vue';

    export default {
        name: 'Overview',
        components: {
            Product
        }
    }
</script>